import React from 'react';
import { Settings as CarouselSettings } from 'react-slick';

import * as Styled from '../../atoms/Carousel/styles';

export const settings: CarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 6000,
  speed: 1000,
  draggable: false,
  fade: true,
  slidesToShow: 1,
  appendDots: (dots: React.ReactNode) => (
    <Styled.CarouselPaginationDots hasLightBg>{dots}</Styled.CarouselPaginationDots>
  ),
  customPaging: () => <Styled.CarouselPagination />,
};
